import SharedBasePersistence from '@/shared/services/persistence/drivers/BasePersistence'

export default class BasePersistence extends SharedBasePersistence {

}